import { render, staticRenderFns } from "./TableJudgesView.vue?vue&type=template&id=3e2de4db"
import script from "./TableJudgesView.vue?vue&type=script&lang=js"
export * from "./TableJudgesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports